import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "fuels";
import { BurnerWalletConnector, FuelWalletConnector, FueletWalletConnector } from "@fuels/connectors";
import { FuelProvider } from "@fuels/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";

const fuelProvider = new Provider("https://testnet.fuel.network/v1/graphql");
const connectors = [
  new FuelWalletConnector(),
  new FueletWalletConnector(),
  new BurnerWalletConnector({ fuelProvider, chainId: 0 }),
];
const queryClient = new QueryClient();

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <FuelProvider fuelConfig={{ connectors }} networks={[{ url: "https://testnet.fuel.network/v1/graphql", chainId: 0 }]} ui>
        <App />
      </FuelProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
